import {useCallback, useEffect, useRef, useState} from "react";

export const PRICES_HUB_TABLE_HOVER_OVERFLOW_X_PX = 26;
export const PRICES_HUB_TABLE_HOVER_OVERFLOW_Y_PX = 4;
const PRICES_HUB_TABLE_HOVER_FADE_MS = 220;

export interface IPricesHubTableHoverMetrics {
    top: number;
    height: number;
    columns: number[];
}

export const usePricesHubTableRowHover = <T extends {slug: string}>(rows: T[]) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const hideTimeoutRef = useRef<number | null>(null);
    const [hoveredSlug, setHoveredSlug] = useState<string | null>(null);
    const [isVisible, setIsVisible] = useState(false);
    const [metrics, setMetrics] = useState<IPricesHubTableHoverMetrics | null>(null);

    const clearHideTimeout = useCallback(() => {
        if (hideTimeoutRef.current === null) {
            return;
        }

        window.clearTimeout(hideTimeoutRef.current);
        hideTimeoutRef.current = null;
    }, []);

    const measureRow = useCallback((rowEl: HTMLTableRowElement) => {
        const wrapper = wrapperRef.current;

        if (!wrapper) {
            return;
        }

        const wrapperRect = wrapper.getBoundingClientRect();
        const rowRect = rowEl.getBoundingClientRect();

        setMetrics({
            top: rowRect.top - wrapperRect.top,
            height: rowRect.height,
            columns: Array.from(rowEl.cells, (cell) => cell.getBoundingClientRect().width)
        });
    }, []);

    const showRow = useCallback(
        (slug: string, rowEl: HTMLTableRowElement) => {
            clearHideTimeout();
            measureRow(rowEl);
            setHoveredSlug(slug);
            setIsVisible(true);
        },
        [clearHideTimeout, measureRow]
    );

    const hide = useCallback(() => {
        setIsVisible(false);
        clearHideTimeout();
        hideTimeoutRef.current = window.setTimeout(() => {
            setHoveredSlug(null);
            setMetrics(null);
            hideTimeoutRef.current = null;
        }, PRICES_HUB_TABLE_HOVER_FADE_MS);
    }, [clearHideTimeout]);

    useEffect(() => {
        return () => {
            clearHideTimeout();
        };
    }, [clearHideTimeout]);

    const hoveredRow = rows.find((row) => row.slug === hoveredSlug) ?? null;

    return {hoveredRow, isVisible, metrics, wrapperRef, showRow, hide};
};
import {useCallback, useEffect, useRef, useState} from "react";

export const PRICES_HUB_TABLE_HOVER_OVERFLOW_X_PX = 26;
export const PRICES_HUB_TABLE_HOVER_OVERFLOW_Y_PX = 4;
const PRICES_HUB_TABLE_HOVER_FADE_MS = 220;

export interface IPricesHubTableHoverMetrics {
    top: number;
    height: number;
    columns: number[];
}

export const usePricesHubTableRowHover = <T extends {slug: string}>(rows: T[]) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const hideTimeoutRef = useRef<number | null>(null);
    const [hoveredSlug, setHoveredSlug] = useState<string | null>(null);
    const [isVisible, setIsVisible] = useState(false);
    const [metrics, setMetrics] = useState<IPricesHubTableHoverMetrics | null>(null);

    const clearHideTimeout = useCallback(() => {
        if (hideTimeoutRef.current === null) {
            return;
        }

        window.clearTimeout(hideTimeoutRef.current);
        hideTimeoutRef.current = null;
    }, []);

    const measureRow = useCallback((rowEl: HTMLTableRowElement) => {
        const wrapper = wrapperRef.current;

        if (!wrapper) {
            return;
        }

        const wrapperRect = wrapper.getBoundingClientRect();
        const rowRect = rowEl.getBoundingClientRect();

        setMetrics({
            top: rowRect.top - wrapperRect.top,
            height: rowRect.height,
            columns: Array.from(rowEl.cells, (cell) => cell.getBoundingClientRect().width)
        });
    }, []);

    const showRow = useCallback(
        (slug: string, rowEl: HTMLTableRowElement) => {
            clearHideTimeout();
            measureRow(rowEl);
            setHoveredSlug(slug);
            setIsVisible(true);
        },
        [clearHideTimeout, measureRow]
    );

    const hide = useCallback(() => {
        setIsVisible(false);
        clearHideTimeout();
        hideTimeoutRef.current = window.setTimeout(() => {
            setHoveredSlug(null);
            setMetrics(null);
            hideTimeoutRef.current = null;
        }, PRICES_HUB_TABLE_HOVER_FADE_MS);
    }, [clearHideTimeout]);

    useEffect(() => {
        return () => {
            clearHideTimeout();
        };
    }, [clearHideTimeout]);

    const hoveredRow = rows.find((row) => row.slug === hoveredSlug) ?? null;

    return {hoveredRow, isVisible, metrics, wrapperRef, showRow, hide};
};
